.feedback-box {
  background-color: var(--color-uva-white);
  display: flex;
  gap: 0.5rem;
  padding: 0.75rem 1rem 0.75rem 0.5rem;
}

.feedback-box > svg {
  flex-shrink: 0;
  height: 1rem;
  margin-top: 0.25rem;
  width: 1rem;
}

.feedback-box__success {
  background-color: var(--color-forest-100);
}

.feedback-box__warning {
  background-color: var(--color-orange-100);
}

.feedback-box__error {
  background-color: var(--color-red-100);
}
